import type { PropertyOf } from 'src/utils/types';

export const ClientTypeByName = {
  Broker: 1,
  Franchisee: 2,
  Franchisor: 3,
  PrivateSeller: 4,
  LicensingDistribution: 5,
} as const;

// As per response payload of GET /api/account .NET endpoint
export const ClientTypeById: Record<
  PropertyOf<typeof ClientTypeByName>,
  keyof typeof ClientTypeByName
> = {
  1: 'Broker',
  2: 'Franchisee',
  3: 'Franchisor',
  4: 'PrivateSeller',
  5: 'LicensingDistribution',
};

export type UserAccountType = keyof typeof ClientTypeByName | 'Buyer';

/* 
  This method for determining the UserAccountType is only temporary. The keys
  here represent the ClientTypeById returned from the GET /api/account .NET endpoint.
  This endpoint will return a valid clientTypeId for all sellers. This endpoint will
  not return a valid clientTypeId for buyers, it will instead return a HTTP 401
  response. This is our only means of learning that the user is a buyer.

  We intend to address this properly when we port these APIs to the new world.
  For the time being we are using this hacky soltion
*/
export const getUserAccountTypeForClientId = (
  clientTypeId?: number,
): UserAccountType => {
  if (clientTypeId === undefined) {
    return 'Buyer';
  }

  // We have to explicitly define as "undefined" given our casted object indexing
  const clientType: PropertyOf<typeof ClientTypeById> | undefined =
    ClientTypeById[clientTypeId as keyof typeof ClientTypeById];

  if (!clientType) {
    throw new Error(`Provided clientTypeId is invalid: ${clientTypeId}`);
  }

  return clientType;
};
